import React, { useEffect, useState } from 'react';
import { Observer } from 'mobx-react';
import {
  Typography,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Dialog,
  DialogActions,
  DialogTitle,
  ListItemSecondaryAction,
  Button,
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import { useHistory } from 'react-router-dom';
import { useRootStore } from '../../stores/BridgeProvider';
import { FlexDiv, StandardBox } from '../styles/styles';
import { safeFalsy } from '../util/UtilFunctions';

const Roles = () => {
  return (
    <Observer
      render={() => {
        const { orgStore, authStore } = useRootStore();
        const [isLoading, setLoading] = useState(true);
        const [roles, setRoles] = useState([]);
        const history = useHistory();
        const [open, setOpen] = useState(false);
        const [selected, setSelected] = useState(0);

        const handleClickOpen = id => {
          setOpen(true);
          setSelected(id);
        };

        const handleClose = () => {
          setOpen(false);
        };

        const getRoles = async () => {
          const { data } = await authStore.request.get(
            `${process.env.REACT_APP_API}/api/roles`,
          );
          setRoles(data.filter(role => !role.IsOwner));
        };
        useEffect(() => {
          const getOrg = async () => {
            await orgStore.retrieveOrgUsers();
          };
          const initialCalls = async () => {
            await Promise.all([getOrg(), getRoles()]);
            setLoading(false);
          };
          initialCalls();
        }, []);
        const deleteRole = async orgRoleId => {
          try {
            await authStore.request.delete(
              `${process.env.REACT_APP_API}/api/role`,
              {
                data: {
                  orgRoleId,
                },
              },
            );
            getRoles();
            handleClose();
          } catch (e) {
            console.error(e);
          }
        };
        return (
          <FlexDiv>
            <StandardBox>
              <Typography
                variant="h4"
                style={{
                  marginTop: '2rem',
                  borderBottom: 'solid 0.5px #E0E0E0',
                  paddingBottom: '1rem',
                }}
              >
                Roles
              </Typography>
              <List>
                {roles.map(({ Name, OrgRoleId }) => (
                  <ListItem key={Name}>
                    <ListItemText primary={Name} />
                    <ListItemSecondaryAction>
                      <IconButton
                        onClick={() => history.push(`/roles/${OrgRoleId}`)}
                      >
                        <EditIcon />
                      </IconButton>
                      <IconButton
                        edge="end"
                        aria-label="delete"
                        onClick={() => handleClickOpen(OrgRoleId)}
                      >
                        <DeleteIcon />
                      </IconButton>
                      <Dialog
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                      >
                        <DialogTitle id="alert-dialog-title">
                          {`Do you really want to delete?`}
                        </DialogTitle>
                        <DialogActions>
                          <Button onClick={handleClose} color="primary">
                            Cancel
                          </Button>
                          <Button
                            onClick={() => deleteRole(selected)}
                            color="primary"
                            autoFocus
                          >
                            Delete
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </ListItemSecondaryAction>
                  </ListItem>
                ))}
                <ListItem>
                  <IconButton onClick={() => history.push(`/role/new`)}>
                    <AddIcon />
                  </IconButton>
                </ListItem>
              </List>
            </StandardBox>
          </FlexDiv>
        );
      }}
    />
  );
};

export default Roles;
